import { Configuration, LiningRegionsApi, LiningsApi, MaterialMainProductGroupsApi, MaterialsApi, SuppliersApi } from '@rhim/rest/linings';

/**
 * "https://apim-apo-dev.azure-api.net/wearmanagement/v1".replace(/\/+$/, "");
 */
const BASE_URL = '/api/liningservice/v1';

const configuration: Configuration = {} as Configuration;

export const linings = new LiningsApi(configuration, BASE_URL);
export const regions = new LiningRegionsApi(configuration, BASE_URL);
export const materials = new MaterialsApi(configuration, BASE_URL);
export const materialMainProductGroups = new MaterialMainProductGroupsApi(configuration, BASE_URL);
export const suppliers = new SuppliersApi(configuration, BASE_URL);
